import { Typography } from '@execonline-inc/execonline-ui';
import { NotTranslated } from '@execonline-inc/translations';
import { observer } from 'mobx-react';

function Divider() {
  return (
    <Typography
      data-testid="footer_divider"
      className="mx-2 leading-none text-foreground"
      variant="bodyMedium"
    >
      <NotTranslated text="|" />
    </Typography>
  );
}

export default observer(Divider);
